module.exports = __webpack_public_path__ + "img/img_main_art.9da43306.png";